import { Controller, get, useFormContext } from "react-hook-form";
import React from "react";
import type { CkeditorField as TCkeditorField } from "src/components/Form/Form.types.ts";
import { CKEditor5 } from "src/components/CKEditor5/CKEditor5.tsx";

export const CkeditorField = ({
  name,
  field,
  isLoading,
  disabled,
}: {
  name: string;
  field: TCkeditorField;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  const form = useFormContext();
  return (
    <Controller
      key={name}
      control={form.control}
      name={name}
      render={({ field: { onChange, value, name }, formState: { errors } }) => {
        // todo: wrap ckeditor in error boundary
        return (
          <CKEditor5
            placeholders={field.placeholders}
            disabled={disabled}
            config={field.config}
            label={field.label}
            isLoading={isLoading}
            height={field.height}
            onChange={onChange}
            error={
              get(errors?.root || {}, name)?.message // server error
            }
            value={value ?? ""}
          />
        );
      }}
    />
  );
};
